<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <loading-spinner v-if="loading" />

    <template v-else-if="item.id">

      <div class="row justify-content-between px-3 mb-4">
        <img
          src="../assets/images/logo-comune.png"
          style="height:80px"
        >
      </div>

      <h2 class="text-center mt-4 text-uppercase">
        Comunicazioni da Roma Capitale
      </h2>
      <div class="text-center">
        Comunicazioni per l'utente da Roma Capitale
      </div>

      <div class="text-left mt-5 ">
        <span>
          <b>Data creazione messaggio: </b>{{item.timeStampCreazione ? moment(item.timeStampCreazione).format('DD/MM/YYYY HH:MM') : '' }}
        </span>
        <br>
        <span>
          <b>Data visione comunicazione: </b>{{item.timeStampVista ? moment(item.timeStampVista).format('DD/MM/YYYY HH:MM') : '' }}
        </span>
        <br>
        <span>
          <b>Data lettura: </b>{{item.timeStampLettura ? moment(item.timeStampLettura).format('DD/MM/YYYY HH:MM') : '' }}
        </span>
        <template v-if="item.timeStampArch">
          <br>
          <span>
            <b>Data archiviazione: </b>{{item.timeStampArch ? moment(item.timeStampArch).format('DD/MM/YYYY HH:MM') : '' }}
          </span>
        </template>
      </div>
      <hr>
      <div>
        <b-form-textarea
          id="textarea-plaintext"
          :value="item.oggetto"
          rows=3
          :readonly="true"
        ></b-form-textarea>
      </div>
      <hr>
      <div>
        <b-form-textarea
          id="textarea-plaintext"
          :value="item.testo"
          rows=8
          :readonly="true"
        ></b-form-textarea>
      </div>

      <div class="row mt-4 mx-2">

        <b-button
          v-if="!item.timeStampLettura"
          variant="success"
          class="m-2"
          @click="doConfermaLettura"
        >
          <font-awesome-icon
            icon="check"
            class="text-white mr-2"
          />Conferma lettura
        </b-button>

        <b-button
          v-if="item.eliminato === 0 && item.timeStampLettura"
          variant="primary"
          class="m-2"
          @click="doArchivia"
        >
          <font-awesome-icon
            icon="save"
            class="text-white mr-2"
          />Archivia
        </b-button>

        <a
          v-if="item.allegato"
          target="_blank"
          :href="urlMessaggio"
        >
          <button class="btn btn-success m-2">
            <font-awesome-icon
              icon="download"
              class="text-white mr-2"
            />Scarica allegato
          </button>
        </a>

        <b-button
          variant="outline-secondary"
          class="m-2"
          @click="back"
        >
          <font-awesome-icon
            icon="times"
            class="mr-2"
          />Chiudi
        </b-button>

      </div>
    </template>

    <b-modal
      ref="confirmModal"
      title="Conferma operazione"
      :centered="true"
      no-close-on-backdrop
      ok-title="Conferma"
      ok-variant="success"
      cancel-title="Annulla"
      cancel-variant="outline-secondary"
    >
      ... testo conferma salvataggio...
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },

  data () {
    return {
      loading: true,
      item: {},
      message: ''
    }
  },

  computed: {
    moment () {
      return moment
    },
    numeral () {
      return numeral
    },
    urlMessaggio () {
      return `/api/messages/${this.item.id}/download`
    }
  },

  async created () {
    await this.load()
  },

  methods: {
    back () {
      this.$router.push({ name: 'messages' })
    },

    async load () {
      try {
        this.loading = true
        let id = this.$route.params.id
        await this.$store.dispatch('messages/loadItemById', id)
        let item = this.$store.state.messages.item
        // console.log('Message item', item)
        // console.log('item.dataConferma', item.dataConferma)
        this.item = item
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },

    doConfermaLettura () {
      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: 'Confermi la resa visione della comunicazione?',
        okHandler: this.doConferma
      })
    },

    async doConferma () {
      try {
        await this.$store.dispatch('messages/confermaLettura', this.item)

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: `Confermata lettura comunicazione!`
        })
        this.back()
      } catch (err) {
        this.$ui.showError(err)
        // back()
      }
      this.loading = false
    },

    async doArchivia () {
      try {
        this.loading = true
        await this.$store.dispatch('messages/archivia', this.item)

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
        this.back()
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    }
  }
}
</script>
